import {fromJS} from 'immutable';
import dieselReducer from '../../decorators/DieselReducer';
import {TabTypes} from '../actions/tab.actions';

const DEFAULT_STATE = fromJS({
    active: 0
});

export function tabReducer(state = DEFAULT_STATE, action) {
    switch (action.type) {
        case TabTypes.SET_ACTIVE_TAB:
            return state.withMutations(newState => {
                newState.set('active', action.tabIndex);
            });
        default:
            return state;
    }
}

export default tabReducer;

dieselReducer('tab', tabReducer);
